export const materialGroupLabel = "Material Group";
export const materialGroupName = "Material Group Name";
export const addMaterialGroupLabel = "Add Material Group";
export const editMaterialGroupLabel = "Edit Material Group";
